module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('l-layout', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4936a17a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/front-main.vue
// module id = 566
// module chunks = 221